import type { SVGProps } from 'react';

const SvgAnnotationArrow = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M18.92 5.62c-.1-.25-.3-.44-.54-.54A1 1 0 0 0 18 5h-5c-.55 0-1 .45-1 1s.45 1 1 1h2.59L5.3 17.29a.996.996 0 0 0 .71 1.7c.26 0 .51-.1.71-.29L17.01 8.41V11c0 .55.45 1 1 1s1-.45 1-1V6c0-.13-.03-.26-.08-.38z"
    />
  </svg>
);
export default SvgAnnotationArrow;
